import { makeApiCall } from '../core';
import type { PicklistItem, PicklistCategory } from '@ruta/shared';
import type { ItemEnvelope, ListEnvelope } from '@ruta/shared';

// =====================
// Picklist Item Management
// =====================

export const getPicklistItems = async (
  category?: PicklistCategory,
): Promise<{ items: PicklistItem[]; count: number }> => {
  const query = category ? `?category=${category}` : '';
  const res = await makeApiCall<ListEnvelope<PicklistItem>>('GET', `/picklist-items${query}`);
  return { items: res.data, count: res.data.length };
};

export const createPicklistItem = async (data: {
  category: PicklistCategory;
  label: string;
  icon?: string;
  customerLabel?: string;
  sortOrder?: number;
}): Promise<{ item: PicklistItem }> => {
  const res = await makeApiCall<ItemEnvelope<PicklistItem>>('POST', '/picklist-items', data);
  return { item: res.data };
};

export const updatePicklistItem = async (
  itemId: string,
  data: {
    label?: string;
    icon?: string;
    customerLabel?: string | null;
    sortOrder?: number;
    isActive?: boolean;
  },
): Promise<{ item: PicklistItem }> => {
  const res = await makeApiCall<ItemEnvelope<PicklistItem>>(
    'PATCH',
    `/picklist-items/${itemId}`,
    data,
  );
  return { item: res.data };
};

export const deletePicklistItem = async (itemId: string): Promise<void> => {
  await makeApiCall<void>('DELETE', `/picklist-items/${itemId}`);
};
